export const defaultBreakpoints = {
  xs: 0, // mobile
  s: 640, // tablet
  m: 1024, // laptop s
  l: 1280, // laptop
  xl: 1536, // laptop l
  xxl: 1920 // normal desktop display
} as const
